import React from 'react';

import { SVGComponentProps } from './svg.types';

const EnvelopeSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="28"
        height="20"
        viewBox="0 0 28 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.00144726 3.28551C0.154149 3.28561 0.309125 3.3208 0.45447 3.39496L14 10.3059L27.5455 3.39496C27.6909 3.3208 27.8458 3.28561 27.9986 3.28551C27.9893 1.866 27.9208 1.09238 27.4142 0.585786C26.8284 0 25.8856 0 24 0H4C2.11438 0 1.17157 0 0.585786 0.585786C0.0791909 1.09238 0.0107056 1.86599 0.00144726 3.28551ZM28 5.40836L14.9089 12.0875C14.338 12.3788 13.662 12.3788 13.0911 12.0875L0 5.40836V16C0 17.8856 0 18.8284 0.585786 19.4142C1.17157 20 2.11438 20 4 20H24C25.8856 20 26.8284 20 27.4142 19.4142C28 18.8284 28 17.8856 28 16V5.40836Z"
          fill="#878A92"
        />
      </svg>
    </span>
  );
};

export default EnvelopeSVG;
